import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const StateContext = createContext();

const getAccessToken = async () => {
  const authorization = Buffer.from(
    `${process.env.REACT_APP_SPOTIFY_CLIENT_ID ?? ""}:${process.env.REACT_APP_SPOTIFY_CLIENT_SECRET ?? ""
    }`
  ).toString("base64");
  const grant = await fetch("https://accounts.spotify.com/api/token", {
    method: "POST",
    headers: {
      Authorization: `Basic ${authorization}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "grant_type=client_credentials",
  });
  const { access_token } = await grant.json();

  return access_token;
};

export const getPlaylist = async (id) => {
  const access_token = await getAccessToken();

  const tracksRequest = await fetch(
    `https://api.spotify.com/v1/playlists/${id}/tracks`,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  const { items } = await tracksRequest.json();

  const playlistRequest = await fetch(
    `https://api.spotify.com/v1/playlists/${id}`,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  const playlist = await playlistRequest.json();

  return {
    data: playlist,
    tracks: items,
  };
};

export const StateContextProvider = ({ children }) => {
  const [songs, setSongs] = useState([]);
  const [contestByGenres, setContestByGenres] = useState([])
  const [genres, setGenres] = useState([]);
  const [currentRound, setCurrentRound] = useState(0);
  const [contest, setContest] = useState();
  const [channels, setChannels] = useState([]);
  const [liveChannels, setLiveChannels] = useState([]);
  const [contests, setContests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [numberOfContests, setNumberOfContests] = useState(-1);

  const getLiveChannels = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/live-categories`).then(
        (response) => {
          setLiveChannels(response.data["queues"]);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getLiveGenres = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/live-genres`).then(
        (response) => {
          setGenres(response.data["genres"]);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getGenres = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/genres`).then(
        (response) => {
          setGenres(response.data["genres"]);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getAllChannels = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/categories`).then(
        (response) => {
          setChannels(response.data["queues"]);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };


  const getContestsGenres = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/contests-by-genres`).then(
        (response) => {
          console.log(response.data)
          setContestByGenres(response.data.genres)
          // setCurrentRound(response.data["round"][0]["name"]);
          // setSongs(response.data["songs"]);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };


  const getAllContests = () => {
    setLoading(true);
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/contests`).then(
        (response) => {
          if (response.data["contests"] !== "Not found") {
            setContests(response.data["contests"].reverse());
            setNumberOfContests(response.data["contests"].length);
          } else {
            setNumberOfContests(0);
          }
          setLoading(false);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getSongs = async (contestId) => {
    setLoading(true);
    if (contestId) {
      setContest(contestId);
      try {
        axios
          .get(
            `${process.env.REACT_APP_BACKEND_API_SERVER}/get-all-song/${contestId}`
          )
          .then(
            (response) => {
              setCurrentRound(response.data["round"][0]["name"]);
              setSongs(response.data["songs"]);
              setLoading(false);
            },
            (error) => {
              console.log(error);
            }
          );
      } catch (error) {
        console.error(error);
      }
    }
    setLoading(false);
  };

  return (
    <StateContext.Provider
      value={{
        songs,
        genres,
        loading,
        contest,
        contests,
        channels,
        liveChannels,
        currentRound,
        contestByGenres,
        numberOfContests,
        getSongs,
        getGenres,
        setContests,
        getLiveGenres,
        getAllContests,
        getAllChannels,
        getLiveChannels,
        getContestsGenres,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
